import { useQuery } from "@tanstack/react-query";
import { pontoApi } from "@/features/ponto/pontoApi";

/**
 * Resolve nomes de usuários (responsável, gerente, funcionário de timesheet...) a partir
 * dos ids de uma lista, numa consulta só (`/api/rh/ponto/usuarios-lookup?ids=`). O lookup
 * não exige a permissão do cadastro de usuários — o `useUsuarios` exige e, sem ela, as telas
 * caíam no "#id". Devolve `nome(id)`, que nunca mostra o id.
 */
export function useNomesUsuarios(ids: (number | null | undefined)[]) {
  const unicos = [...new Set(ids.filter((i): i is number => !!i && i > 0))].sort((a, b) => a - b);

  const { data = [], isLoading } = useQuery({
    queryKey: ["usuarios-lookup-ids", unicos],
    queryFn: () => pontoApi.usuarios(undefined, unicos),
    enabled: unicos.length > 0,
    staleTime: 5 * 60_000,
  });

  const mapa = new Map(data.map((u) => [u.id, u.nome || u.login]));
  const nome = (id: number | null | undefined, vazio = "—") => {
    if (!id) return vazio;
    return mapa.get(id) ?? (isLoading ? "…" : "(usuário inativo)");
  };
  return { nome };
}
